import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://examplePublicKey@o0.ingest.sentry.io/0",
  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: [],
  },
});
